module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [(_vm.display) ? _c('div', {
    staticClass: "box shadow"
  }, [_c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "out-in"
    }
  }, [_c(_vm.view, {
    tag: "component",
    on: {
      "cancel": _vm.hideSignupForm,
      "signup": _vm.displaySignupForm
    }
  })], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-184c0657"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 18
// module chunks = 0